import React,{useEffect,useState,useRef} from 'react'
import {InputText} from 'primereact/inputtext'
import { Button } from 'primereact/button'
import {Messages} from 'primereact/messages'
import './PasswordReset.css'
import {useSelector,useDispatch} from 'react-redux'
import {getResetpasswordUserInfo,updateResetPasswordUserInfo} from '../../../actions'
import check from '../../../images/check.jpg'

const VerifyReference = (props)=>{

    const messages = useRef(null)
    const dispatch = useDispatch()
    const [showCheck, setShowCheck] = useState(false)
    const userinfo = useSelector(state=>state.resetPasswordUserInfoReducers)
    const [requestingGetUserInfo,setRequestingGetUserInfo] = useState(false)  
    const isFirstRender = useRef(true)
  
    useEffect(() => {
      if (isFirstRender.current) {
        isFirstRender.current = false
        return
      }
  
      if (requestingGetUserInfo && userinfo.requesting_get_successful) {
        props.setActiveIndex(1)
        setRequestingGetUserInfo(false)
      }
      if (requestingGetUserInfo && userinfo.message !== null) {
        if (userinfo.infoError !== null) {
            messages.current.show({ severity: 'error', summary: "", detail: userinfo.message, sticky: true });
          } else if (userinfo.message !== null) {
            props.toast.current.show({ severity: 'error', summary: "Retrieve ResetPassword User Info API", detail: userinfo.message, sticky: true });
          }
          
          setRequestingGetUserInfo(false)
      }
    })
  

    const fetchResetPasswordUserInfo = ()=>{
      dispatch(getResetpasswordUserInfo({refnum:userinfo.data.refnum}))
      setRequestingGetUserInfo(true)
    }
    
    const [invalid, setInvalid] = useState({
        refnum: false,
        firstname: false,
        lastname: false,
        dob: false,
        ssn: false,
        ssn_min_length: false
    })
    
    const resetValidation = (fields) => {
        var fieldsUpdate = {}
        if (typeof (fields) === 'string') {
          fieldsUpdate[`${fields}`] = false
        } else if (Array.isArray(fields)) {
          fields.forEach((item => {
            fieldsUpdate[`${item}`] = false
          }))
        }
        setInvalid(Object.assign({}, invalid, fieldsUpdate))
    }
    
    const validateOnSubmit = () => {
        var allowSubmit = true;
        var invalidJSON = {}
       
      
        if (userinfo.data.refnum === null) {
          Object.assign(invalidJSON, { refnum: true })
          allowSubmit = false
        }
        if (allowSubmit) {
          fetchResetPasswordUserInfo()
        } else {
          setInvalid(Object.assign({}, invalid, invalidJSON))
        }
    }

    const [backurl, setBackUrl] = useState(null)
    const [appname,setAppName] = useState(null)
    useEffect(() => {
  
          const queryParams = new URLSearchParams(window.location.search)
          const backbtnurl = queryParams.get("backbtnurl")
          const appnameparam = queryParams.get("appname")
          const loginparam = queryParams.get("login")
          if (backbtnurl !== null && backbtnurl !== '') { 
            setBackUrl(`${backbtnurl.replace('/login.html','')}/oauth2/authorization/oracle`)
          }
          if (appnameparam !== null && appnameparam !== '') {
            setAppName(appnameparam)
          }
    }, [])

    return <div>
        <div className="reference-input-message">Enter your reference number to proceed.</div>
        <Messages ref={messages}></Messages>
        <div className="password-input-container">
        {showCheck ? <div className="check-container resetpassword-check-container"><img src={check} alt="check" /></div> : null}
        <div className="reference-title">Reference Number&nbsp;&nbsp;<span className="need-help" onClick={() => {
            setShowCheck(!showCheck)
          }}>(Need help to find your ID Number?)</span></div>
        <div><InputText value={userinfo.data.refnum||''} onChange={(e)=>{
            resetValidation('refnum')
            dispatch(updateResetPasswordUserInfo(Object.assign({},userinfo.data,{refnum:e.target.value !== '' ? e.target.value : null})))
        }}/>
         {invalid.refnum ? <small> <div className="p-error top-margin">Reference number is required</div></small> : null}
        </div>
        <div className="continue-btn"><Button disabled={requestingGetUserInfo} onClick={()=>{
             if(requestingGetUserInfo){
               return
             }
             validateOnSubmit()
        }}>{requestingGetUserInfo ? <i className="pi pi-spin pi-spinner"></i>:<span>&nbsp;&nbsp;</span>}&nbsp;Continue</Button></div>
        </div>
        {backurl ? 
            <div className="row-btn">
                <span className="row-btn-link"><a href={backurl||props.defaultLoginURL}>{`${appname!==null ? `Back to ${appname}` : 'Back'}`}</a></span>
            </div> 
        : <div className="row-btn">
            <span className="row-btn-link"><a href={props.defaultLoginURL}>Back</a></span>
          </div> }
        {/* <div className="row-btn">
          <span className="row-btn-link">Need help? Check out our FAQs</span>
        </div> */}
    </div>
}

export default VerifyReference